import {
	type FetchUserUsersSearchData,
	type FetchUserUsersSearchParams,
	hoursToMs,
	SociosApi,
	type UserChiliPayUserPublic
} from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { chiliPayUserApi } from '../api';

export const UseUserSearchQueryKeyBuilder = (queryParams: FetchUserUsersSearchParams) => ['users', queryParams];

/**
 * /!\ This query will be run only when there is a text and the responses are cache by searchText (similarUsername)
 *  through  UseUserSearchQueryKeyBuilder.
 */
export const useUserSearchQueries = (
	queryParams: FetchUserUsersSearchParams,
	options?: Omit<
		UseQueryOptions<FetchUserUsersSearchData, unknown, Array<UserChiliPayUserPublic> | undefined>,
		'queryFn'
	>
) => {
	return useQuery<FetchUserUsersSearchData, unknown, Array<UserChiliPayUserPublic> | undefined>({
		enabled: !!queryParams?.similarUsername,
		queryFn: async () =>
			(await chiliPayUserApi).fetchUserUsersSearch(
				{
					'details[]': ['userImages'],
					...queryParams
				} as FetchUserUsersSearchParams,
				{
					headers: SociosApi.prepareEDTOHeaders([
						{
							at: '/data/*/externalUserId',
							fetch: 'UserService:User:byExternalUserId',
							into: 'user'
						}
					])
				}
			),
		queryKey: UseUserSearchQueryKeyBuilder(queryParams),
		refetchOnWindowFocus: false,
		select: res => res.data || [],
		staleTime: hoursToMs(1),
		...options
	});
};
